import Reveal from '@/components/feature/Reveal';

interface SectionTitleProps {
  eyebrow: string;
  title: string;
  desc?: string;
  align?: 'center' | 'left';
}

export default function SectionTitle({ eyebrow, title, desc, align = 'center' }: SectionTitleProps) {
  const alignCls = align === 'center' ? 'items-center text-center' : 'items-start text-left';
  return (
    <Reveal className={`flex flex-col ${alignCls}`}>
      <span className="inline-flex items-center gap-1.5 rounded-full bg-primary-100 px-3.5 py-1 text-xs font-semibold text-primary-700">
        <i className="ri-sparkling-2-fill"></i>
        {eyebrow}
      </span>
      <h2 className="mt-4 font-heading text-2xl text-foreground-950 md:text-4xl">{title}</h2>
      {desc && <p className="mt-3 max-w-2xl text-sm leading-7 text-foreground-600 md:text-base">{desc}</p>}
    </Reveal>
  );
}